export const ACCOUNT_VERIFICATION_CANCELLED = 'ACCOUNT_VERIFICATION_CANCELLED'
export const ACCOUNT_VERIFICATION_FAILED = 'ACCOUNT_VERIFICATION_FAILED'
export const ACCOUNT_VERIFICATION_UNKNOWN_ERROR =
  'ACCOUNT_VERIFICATION_UNKNOWN_ERROR'
export const ACCOUNT_VERIFICATION_INITIALIZATION_FAILED =
  'ACCOUNT_VERIFICATION_INITIALIZATION_FAILED'
export const ACCOUNT_PASSWORD_VERIFICATION_FAILED =
  'ACCOUNT_PASSWORD_VERIFICATION_FAILED'
